import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _isCollapsed$ = new BehaviorSubject<boolean>(false);

  public get isCollapsed$(): Observable<boolean> {
    return this._isCollapsed$.asObservable();
  }

  public get isCollapsed(): boolean {
    return this._isCollapsed$.value;
  }

  public collapseSidebar(): void {
    this._isCollapsed$.next(true);
  }

  public openSidebar(): void {
    this._isCollapsed$.next(false);
  }

  public toggleSidebar(): void {
    this._isCollapsed$.next(!this._isCollapsed$.value);
  }

  public setSidebarState(collapsed: boolean): void {
    this._isCollapsed$.next(collapsed);
  }
}
